/* ==========================================================================
   MT — JavaScript propio (vanilla, sin librerías)
   Un init por componente. Cada uno sale pronto si su elemento no existe,
   así el mismo archivo sirve para todas las páginas.
   ========================================================================== */
(function () {
  'use strict';

  /* Varias secciones incluyen este mismo archivo. Sin este guardia el script
     se ejecuta una vez por seccion y cada boton acaba con varios escuchadores
     de clic, que se anulan entre si (el acordeon del FAQ no abria). */
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada --------------------------------------------- */
  function initReveal() {
    var elems = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!elems.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      elems.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    elems.forEach(function (el) { obs.observe(el); });
  }

  /* --- Escalonado automático dentro de un grupo ---------------------------- */
  function initStagger() {
    document.querySelectorAll('[data-mt-stagger]').forEach(function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-mt-stagger'), 10) || 90;
      var hijos = grupo.querySelectorAll(':scope > .mt-reveal');
      hijos.forEach(function (hijo, i) {
        hijo.style.setProperty('--mt-delay', (i * paso) + 'ms');
      });
    });
  }

  /* --- FAQ (acordeón con altura animada) ----------------------------------- */
  function initFaq() {
    var listas = document.querySelectorAll('[data-mt-faq]');
    if (!listas.length) return;

    listas.forEach(function (lista) {
      var soloUno = lista.getAttribute('data-mt-faq-solo') === 'true';
      var items = lista.querySelectorAll('.mt-faq__item');

      items.forEach(function (item) {
        var btn = item.querySelector('.mt-faq__btn');
        var panel = item.querySelector('.mt-faq__panel');
        if (!btn || !panel) return;
        if (item.getAttribute('data-mt-faq-listo')) return;
        item.setAttribute('data-mt-faq-listo', '1');

        function abrir() {
          item.classList.add('mt-abierto');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
          window.setTimeout(function () {
            if (item.classList.contains('mt-abierto')) panel.style.height = 'auto';
          }, 520);
        }
        /* Se fuerza un reflow en vez de encadenar requestAnimationFrame:
           rAF no se ejecuta en pestanas ocultas y el panel se quedaba abierto. */
        function cerrar() {
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
          void panel.offsetHeight;
          item.classList.remove('mt-abierto');
          btn.setAttribute('aria-expanded', 'false');
          void panel.offsetHeight;
          panel.style.height = '0px';
        }

        btn.addEventListener('click', function () {
          var abierto = item.classList.contains('mt-abierto');
          if (soloUno && !abierto) {
            items.forEach(function (otro) {
              if (otro === item || !otro.classList.contains('mt-abierto')) return;
              var oPanel = otro.querySelector('.mt-faq__panel');
              var oBtn = otro.querySelector('.mt-faq__btn');
              oPanel.style.height = oPanel.firstElementChild.offsetHeight + 'px';
              void oPanel.offsetHeight;
              otro.classList.remove('mt-abierto');
              if (oBtn) oBtn.setAttribute('aria-expanded', 'false');
              void oPanel.offsetHeight;
              oPanel.style.height = '0px';
            });
          }
          abierto ? cerrar() : abrir();
        });
      });
    });
  }

  /* --- Marquesinas: duplica el grupo para que el bucle sea continuo -------- */
  function initMarquesinas() {
    document.querySelectorAll('[data-mt-marquesina]').forEach(function (pista) {
      if (pista.getAttribute('data-mt-lista') === 'si') return;
      var grupo = pista.firstElementChild;
      if (!grupo) return;
      var copia = grupo.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      pista.appendChild(copia);
      pista.setAttribute('data-mt-lista', 'si');
    });
  }

  /* --- Galería del producto ------------------------------------------------ */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var minis = Array.prototype.slice.call(galeria.querySelectorAll('[data-mt-mini]'));
      if (!principal || !minis.length) return;

      // Cambia la foto principal a la miniatura del índice dado (con vuelta
      // al principio/final, así las flechas nunca se quedan "atascadas" en
      // el primer o el último extremo).
      function irA(indice) {
        var total = minis.length;
        var i = ((indice % total) + total) % total;
        var mini = minis[i];
        var src = mini.getAttribute('data-mt-src');
        var alt = mini.getAttribute('data-mt-alt') || '';
        if (!src) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.setAttribute('src', src);
          principal.setAttribute('alt', alt);
          principal.style.opacity = '1';
        }, 180);
        minis.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
        if (mini.scrollIntoView) {
          mini.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      minis.forEach(function (mini, i) {
        mini.addEventListener('click', function () { irA(i); });
      });

      // Flechas a los lados de la foto principal, para pasar las imágenes
      // sin tener que tocar las miniaturas.
      var anterior = galeria.querySelector('[data-mt-galeria-prev]');
      var siguiente = galeria.querySelector('[data-mt-galeria-next]');
      function indiceActivo() {
        var i = minis.findIndex(function (m) { return m.classList.contains('mt-activa'); });
        return i === -1 ? 0 : i;
      }
      if (anterior) anterior.addEventListener('click', function () { irA(indiceActivo() - 1); });
      if (siguiente) siguiente.addEventListener('click', function () { irA(indiceActivo() + 1); });
    });
  }

  /* --- Selector de packs por cantidad -------------------------------------- */
  /* El producto tiene una sola variante. Cada "pack" es esa variante en una
     cantidad distinta (1 o 2). Al elegir un pack se actualiza el precio
     mostrado y la cantidad que se añade al carrito; el precio real del pack de
     2 lo aplica el descuento automático de Shopify en el pago. */
  function initPacks() {
    var bloques = document.querySelectorAll('[data-mt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var packs = bloque.querySelectorAll('[data-mt-pack]');
      if (!packs.length) return;

      var cantidad = bloque.querySelector('[data-mt-cantidad]');
      var precio = bloque.querySelector('[data-mt-precio-actual]');
      var precioAntes = bloque.querySelector('[data-mt-precio-antes]');
      var ahorro = bloque.querySelector('[data-mt-ahorro]');

      function aplicar(btn) {
        if (cantidad) cantidad.value = btn.getAttribute('data-mt-qty') || '1';
        var p = btn.getAttribute('data-mt-precio');
        if (precio && p) precio.innerHTML = p;

        var antes = btn.getAttribute('data-mt-antes');
        if (precioAntes) {
          if (antes) { precioAntes.innerHTML = antes; precioAntes.hidden = false; }
          else { precioAntes.hidden = true; }
        }

        var pct = parseInt(btn.getAttribute('data-mt-pct'), 10);
        if (ahorro) {
          if (pct > 0) { ahorro.textContent = '−' + pct + '%'; ahorro.hidden = false; }
          else { ahorro.hidden = true; }
        }
      }

      packs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          packs.forEach(function (b) { b.classList.remove('mt-activa'); });
          btn.classList.add('mt-activa');
          aplicar(btn);
        });
      });

      var inicial = bloque.querySelector('[data-mt-pack].mt-activa') || packs[0];
      if (inicial) aplicar(inicial);
    });
  }

  /* --- Fecha de entrega de la línea de tiempo ------------------------------
     Se calcula en el navegador de cada visitante: hoy + los días fijados en
     el bloque. Así siempre está al día sin tener que tocar el tema nunca. */
  function initFechaEntrega() {
    var elems = document.querySelectorAll('[data-mt-fecha-entrega]');
    if (!elems.length) return;
    var meses = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    elems.forEach(function (el) {
      var dias = parseInt(el.getAttribute('data-mt-dias'), 10) || 14;
      var f = new Date();
      f.setDate(f.getDate() + dias);
      el.textContent = meses[f.getMonth()] + ' ' + f.getDate();
    });
  }

  /* --- Contador de la oferta ------------------------------------------------
     Cuenta atrás sincronizada para TODOS los visitantes a la vez: en vez de
     arrancar desde que cada uno entra, se calcula a partir del reloj real
     (Date.now()), así que dos personas mirando la página en el mismo
     instante ven exactamente el mismo tiempo restante. Al llegar a 0 vuelve
     a arrancar sola, porque el cálculo es un resto de división (% ciclo). */
  function initContador() {
    var elems = document.querySelectorAll('[data-mt-contador]');
    if (!elems.length) return;

    elems.forEach(function (el) {
      var reloj = el.querySelector('[data-mt-contador-reloj]');
      if (!reloj) return;
      var minutos = parseInt(el.getAttribute('data-mt-contador-minutos'), 10) || 60;
      var cicloMs = minutos * 60 * 1000;

      function pintar() {
        var restanteMs = cicloMs - (Date.now() % cicloMs);
        var segundos = Math.ceil(restanteMs / 1000);
        if (segundos > 3600) segundos = segundos % 3600;
        var h = Math.floor(segundos / 3600);
        var m = Math.floor((segundos % 3600) / 60);
        var s = segundos % 60;
        var texto = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (h > 0) texto = h + ':' + texto;
        reloj.textContent = texto;
      }

      pintar();
      if (el.getAttribute('data-mt-contador-listo')) return;
      el.setAttribute('data-mt-contador-listo', '1');
      window.setInterval(pintar, 1000);
    });
  }

  /* --- "X people have this in their cart" ----------------------------------
     Número que cambia cada cierto tiempo dentro del rango configurado. Cada
     visitante ve su propio valor (no hace falta que coincida entre ellos). */
  function initCarrito() {
    var elems = document.querySelectorAll('[data-mt-carrito]');
    if (!elems.length) return;

    elems.forEach(function (el) {
      var texto = el.querySelector('[data-mt-carrito-texto]');
      if (!texto) return;

      if (!el.getAttribute('data-mt-carrito-base')) {
        el.setAttribute('data-mt-carrito-base', texto.textContent);
      }
      var base = el.getAttribute('data-mt-carrito-base');
      var min = parseInt(el.getAttribute('data-mt-carrito-min'), 10) || 6;
      var max = parseInt(el.getAttribute('data-mt-carrito-max'), 10) || 19;
      if (max < min) max = min;

      function pintar() {
        var n = min + Math.floor(Math.random() * (max - min + 1));
        texto.textContent = base.replace('[n]', n);
      }

      pintar();
      if (el.getAttribute('data-mt-carrito-listo')) return;
      el.setAttribute('data-mt-carrito-listo', '1');
      window.setInterval(pintar, 26000 + Math.floor(Math.random() * 14000));
    });
  }

  /* --- Parallax muy suave del visual del hero ------------------------------ */
  function initParallax() {
    if (reduce) return;
    var elems = document.querySelectorAll('[data-mt-parallax]');
    if (!elems.length) return;
    if (window.innerWidth < 990) return;

    var pendiente = false;
    function pintar() {
      pendiente = false;
      var y = window.pageYOffset;
      elems.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-mt-parallax')) || 0.06;
        el.style.transform = 'translate3d(0,' + (y * f).toFixed(2) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }, { passive: true });
    pintar();
  }

  function initTodo() {
    initStagger();
    initReveal();
    initFaq();
    initMarquesinas();
    initGaleria();
    initPacks();
    initFechaEntrega();
    initContador();
    initCarrito();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }

  /* El editor de Shopify recarga secciones sueltas: re-inicializa lo necesario */
  document.addEventListener('shopify:section:load', initTodo);
})();
